// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__3xuxc","obliqueLineWrap":"membershipbadge_obliqueLineWrap__2Ts1n","obliqueLine":"membershipbadge_obliqueLine__dojKN"};